import featureFlag from '../../application/common/featureFlag';

export interface DealOwnerConfig {
  setterLabel: string;
  closerLabel: string | null;
  hideCloser: boolean;
}

export function getDealOwnerConfig(): DealOwnerConfig {
  if (featureFlag('noSetterCloser')) {
    return { setterLabel: 'Rep', closerLabel: null, hideCloser: true };
  }
  return { setterLabel: 'Setter', closerLabel: 'Closer', hideCloser: false };
}

export function getFunctionalRoleLabel(rawRole: string): string {
  const config = getDealOwnerConfig();

  switch (rawRole) {
    case 'setter':
      return config.setterLabel;
    case 'closer':
      return config.hideCloser ? config.setterLabel : config.closerLabel!;
    case 'setter_closer':
      if (config.hideCloser) {
        return config.setterLabel;
      }
      return `${config.setterLabel} / ${config.closerLabel}`;
    case 'manager':
      return 'Manager';
    case 'other':
      return 'Other';
    default:
      return 'Undefined';
  }
}
